import React from 'react';

import TextField from '@mui/material/TextField';

import { useField } from 'app-components/flux/categories/categoryFormHooks';

const CategoryName = () => {
  const { value, onValueChange, error, helperText, disabled } = useField('name');
  return (
    <TextField
      id='add-category-name'
      name='name'
      label='Name'
      variant='filled'
      defaultValue={value}
      onChange={(event) => onValueChange(event.target.value)}
      error={error}
      helperText={helperText}
      disabled={disabled}
    />
  );
};

export default CategoryName;
